import {MuiIcon, MuiIconExternalProps} from "./MuiIcon";
import React from "react";

export const KeyIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue73c'}</MuiIcon>
        );
    }
)
